import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../styles/stylesInicio.css';

const Inicio = () => {
    const { hash } = useLocation();
    const carouselRef = useRef(null);
    
    // Referencia para saber la dirección actual del auto-scroll ('right' o 'left')
    const directionRef = useRef('right'); 
    
    const [noticiasDestacadas, setNoticiasDestacadas] = useState([]);
    const [loadingNoticias, setLoadingNoticias] = useState(true);

    // 1. SCROLL AL HASH
    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        if (hash.includes('error')) return;

        try {
            const elem = document.querySelector(hash);
            if (elem) {
                elem.scrollIntoView({ behavior: 'smooth' });
            }
        } catch (e) {
            console.warn('Hash inválido ignorado:', hash);
        }
    }, [hash]);

    // 2. FETCH NOTICIAS
    useEffect(() => {
        const fetchNoticiasHome = async () => {
            try {
                setLoadingNoticias(true);
                const { data, error } = await supabase
                    .from('noticias')
                    .select('id, titulo, resumen, fecha, imagen_url')
                    .order('fecha', { ascending: false })
                    .limit(6);

                if (error) throw error;
                setNoticiasDestacadas(data || []);
            } catch (error) {
                console.error("Error cargando noticias:", error);
            } finally {
                setLoadingNoticias(false);
            }
        };

        fetchNoticiasHome();
    }, []);

    // 3. LÓGICA DE SCROLL
    const getScrollAmount = () => {
        if (carouselRef.current && carouselRef.current.firstChild) {
            return carouselRef.current.firstChild.clientWidth + 20; 
        }
        return 350;
    };

    const scroll = (direction) => {
        if(carouselRef.current) {
            const { current } = carouselRef;
            const amount = getScrollAmount();
            
            if (direction === 'left') {
                current.scrollBy({ left: -amount, behavior: 'smooth' });
            } else {
                current.scrollBy({ left: amount, behavior: 'smooth' });
            }
        }
    };

    // Auto-Scroll Ping-Pong
    useEffect(() => {
        const interval = setInterval(() => {
            if (carouselRef.current) {
                const { current } = carouselRef;
                const amount = getScrollAmount();
                const maxScrollLeft = current.scrollWidth - current.clientWidth;

                if (directionRef.current === 'right') {
                    if (current.scrollLeft >= maxScrollLeft - 10) {
                        directionRef.current = 'left';
                        current.scrollBy({ left: -amount, behavior: 'smooth' });
                    } else {
                        current.scrollBy({ left: amount, behavior: 'smooth' });
                    }
                } else {
                    if (current.scrollLeft <= 10) {
                        directionRef.current = 'right';
                        current.scrollBy({ left: amount, behavior: 'smooth' });
                    } else {
                        current.scrollBy({ left: -amount, behavior: 'smooth' });
                    }
                }
            }
        }, 4000); 

        return () => clearInterval(interval);
    }, [noticiasDestacadas]); 

    return (
        <div className="inicio-wrapper">
            
            {/* --- SECCIÓN 1: PORTADA --- */}
            <section className="seccionInicio" id="seccion1Inicio">
                <div className="inicio-split-container">
                    <div className="inicio-image-container">
                        <img
                            src="/resources/comuna.jpg"
                            className="inicio-image-bg"
                            alt="Santo Domingo"
                        />
                        <div className="inicio-overlay"></div>
                    </div>

                    <div className="inicio-glass-card">
                        <div className="inicio-text-content">
                            <h1 className="inicio-titulo">Bienvenidos a la Comuna de <br/> <span>Santo Domingo</span></h1>
                            <p className="inicio-subtitulo">
                                Gestión que avanza, comunidad que crece.
                            </p>
                            <div className="inicio-actions">
                                <Link to="/Tramites" className="btn-modern-primary">Realizar Trámite</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* --- SECCIÓN 2: ÚLTIMAS NOTICIAS (FONDO #E8EFFD) --- */}
            <section className="seccion-noticias-destacadas">
                
                {/* YA NO HAY VIDEO AQUÍ */}

                <div className="noticias-content-wrapper">
                    <div className="noticias-header">
                        <h2>Últimas Novedades</h2>
                        <p>Mantente informado sobre lo que pasa en nuestro pueblo</p>
                    </div>

                    <div className="carousel-wrapper">
                        <button className="carousel-btn left" onClick={() => scroll('left')}>‹</button>

                        <div className="noticias-carousel" ref={carouselRef}>
                            
                            {loadingNoticias && (
                                <p style={{textAlign: 'center', width: '100%', color: '#092659'}}>Cargando novedades...</p>
                            )}

                            {!loadingNoticias && noticiasDestacadas.map((noticia) => (
                                <Link 
                                    to={`/Noticias/${noticia.id}`} 
                                    key={noticia.id} 
                                    className="noticia-card-large" 
                                >
                                    <div className="noticia-img-wrap">
                                        <img 
                                            src={noticia.imagen_url || '/resources/comuna.jpg'} 
                                            alt={noticia.titulo} 
                                            onError={(e) => {e.target.src = '/resources/comuna.jpg'}} 
                                        />
                                        <span className="noticia-fecha">
                                            {new Date(noticia.fecha).toLocaleDateString()}
                                        </span>
                                    </div>
                                    <div className="noticia-info">
                                        <h3>{noticia.titulo}</h3>
                                        <p>{noticia.resumen ? noticia.resumen.substring(0, 100) + '...' : ''}</p>
                                        <span className="leer-mas">Leer más →</span>
                                    </div>
                                </Link>
                            ))}

                            {!loadingNoticias && noticiasDestacadas.length === 0 && (
                                <p style={{textAlign: 'center', width: '100%', color: '#092659'}}>No hay noticias recientes.</p>
                            )}

                        </div>

                        <button className="carousel-btn right" onClick={() => scroll('right')}>›</button>
                    </div>

                    <div className="ver-todas-container">
                        <Link 
                            to="/Noticias" 
                            className="btn-ver-todas"
                            onClick={() => window.scrollTo(0, 0)}
                        >
                            VER MÁS NOTICIAS
                        </Link>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Inicio;